import { B2B_COPILOT_PLAN_KEY_DESIGN_CLOSING } from './b2bCopilotPlanDemoContent.part04.js'

export const B2B_COPILOT_PLAN_KEY_DESIGN_MARKDOWN = `### Key Design Calls Baked In

- **pgvector + PG full-text search for hybrid retrieval** — no Elasticsearch needed, keeps infra lean
- **SQLModel** so Pydantic models and ORM tables share definitions
- **LLM never does math** — all analytics are deterministic pandas; LLM only synthesizes prose
- **Conflict detection built into the graph** — overlapping policy docs and alias mismatches trigger \`needs_review\`
- **Benchmark set has 15 queries** covering all 5 route types, including conflicting-evidence traps

${B2B_COPILOT_PLAN_KEY_DESIGN_CLOSING}`

/**
 * @param {string} planArtifactId
 * @param {string} [zipArtifactId]
 * @returns {object[]}
 */
